import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { Modal, Form, Button } from 'react-bootstrap'

import { IMaskInput } from "react-imask"

import axios from 'axios'

export default class FeedbackForm extends Component {

  constructor(props) {
    super(props)

    this.state = {
      name: ``,
      phone: ``,
      show_msg: false,
      modal_body: ``,
      isSending: false // Добавляем состояние для отслеживания отправки
    }
  }

  changeName( name ) {
    this.setState({
      name: name
    })
  }
  changePhone( phone ) {
    this.setState({
      phone: phone
    })
  }

  handleShow_msg( text ) {
    this.setState({
      show_msg: true,
      modal_body: text
    })
  }
  handleClose_msg() {
    this.setState({
      show_msg: false
    })
  }

  sendForm = ( e ) => {
    const { title, data } = this.props,
    { name, phone, isSending } = this.state

    e.preventDefault()

    // Если уже идет отправка, ничего не делаем
    if (isSending) return;

    const main = this,
    baseURL = window.location.protocol + "//" + window.location.hostname
    
    // Устанавливаем состояние отправки
    this.setState({ isSending: true })
    
    axios.post(`${baseURL}`, {
      'content_type': 'application/json',
      'action': 'feedback_form',
      'form': title,
      'name': name,
      'phone': phone,
      'json': JSON.stringify( data )
    }, {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Request-Source': 'Node.js'
      }
    }).then( ( response ) => {
      if( response.data.result ) {
        main.props.handleClose()
        main.handleShow_msg( `Сообщение отправлено, наш менеджер свяжется с вами в ближайшее время.` )
        setTimeout(() => { window.location.href = `${baseURL}/spasibo` }, 2000)
      } else {
        main.handleShow_msg( response.data?.message || `Произошла ошибка при отправке формы. Пожалуйста, проверьте данные.` )
      }
    }).catch(error => {
      // Обработка ошибок, если нужно
      console.error('Error sending form:', error)
    }).finally(() => {
      // В любом случае снимаем состояние отправки
      this.setState({ isSending: false })
    })
  }

  render() {

    const { title, text, btn, show, handleClose } = this.props,
    { show_msg, modal_body, isSending } = this.state

    return (
      <>
        <Modal show={show} onHide={handleClose} centered>
          <Modal.Header closeButton>
            <div></div>
          </Modal.Header>
          <Modal.Body>
            <Modal.Title className="mb-2">{title}</Modal.Title>
            {text &&
              <p className='modal-text'>{text}</p>
            }
            <Form onSubmit={( e ) => this.sendForm( e )}>
              <Form.Group className="mb-2">
                <Form.Control name="fio" required onChange={( e ) => this.changeName( e.target.value )} type="text" placeholder="Ваше имя" />
              </Form.Group>
              <Form.Group className="mb-2">
                <Form.Control name="phone" required onChange={( e ) => this.changePhone( e.target.value )} as={IMaskInput} mask="+{7} (000) 000-00-00" lazy={true} type="phone" placeholder="Номер телефона" />
              </Form.Group>
              <Button 
                type="submit" 
                className='w-100 text-white mb-2' 
                variant="primary"
                disabled={isSending}
              >
                {isSending ? 'Отправляется...' : (btn !== `` ? btn : `Отправить`)}
              </Button>
              <Form.Check
                type='radio'
                label={(
                  <>Нажимая на кнопку “Отправить”, вы соглашаетесь с <a target="_blank" style={{ color: `#0009` }} href="/privacy">политикой конфиденциальности</a></>
                )}
                checked={true}
                className='mb-3'
              />
            </Form>
          </Modal.Body>
        </Modal>
        <Modal centered show={show_msg} onHide={() => this.handleClose_msg()}>
          <Modal.Header closeButton>
            <div></div>
          </Modal.Header>
          <Modal.Body>
            <Modal.Title>{title}</Modal.Title>
            <div className='modal-text mt-2'>{modal_body}</div>
          </Modal.Body>
        </Modal>
      </>
    )
  }
}

FeedbackForm.propTypes = {
  title: PropTypes.string,
  text: PropTypes.string,
  btn: PropTypes.string,
  data: PropTypes.array,
  show: PropTypes.bool,
  handleClose: PropTypes.func
}